<template>
  <v-form
    class="relaxation"
    @submit.prevent="next"
  >
    <template v-if="isPreviewMode">
      <preview-relaxation-component>
        <template
          v-if="$vuetify.theme.options.logo"
          v-slot:logo
        >
          <img
            :src="$vuetify.theme.options.logo"
            alt="Adhere"
          >
        </template>
        <template v-slot:body>
          <template v-if="isSelected === 'relaxation-show'">
            <relaxation-balloon
              :time-id="notificationId"
              :session="session"
              :duration="params.duration"
              dense
              @stats="$emit('stats', $event)"
            />
          </template>
          <template v-if="isSelected === 'relaxation2-show'">
            <relaxation-ball
              :time-id="notificationId"
              :session="session"
              :duration="params.duration"
              dense
              @stats="$emit('stats', $event)"
            />
          </template>
        </template>

        <relaxation-select
          :is-selected="isSelected"
          dense
          @action-selected="isSelected = $event"
        />
      </preview-relaxation-component>

      <actions
        v-if="showPrevButton"
        :label="params.nextBtnLabel"
        :icon="params.nextBtnLabel ? null : undefined"
      />
    </template>
    <template v-else>
      <template v-if="isSelected === 'relaxation-show'">
        <relaxation-balloon
          :time-id="notificationId"
          :session="session"
          :duration="params.duration"
          @stats="$emit('stats', $event)"
        />
      </template>
      <template v-if="isSelected === 'relaxation2-show'">
        <relaxation-ball
          :time-id="notificationId"
          :session="session"
          :duration="params.duration"
          @stats="$emit('stats', $event)"
        />
      </template>

      <actions
        v-if="showPrevButton"
        wrapper-class="confirm-absolute justify-center justify-sm-space-between align-end flex-wrap"
        :label="params.nextBtnLabel"
        :icon="params.nextBtnLabel ? null : undefined"
      >
        <relaxation-select
          :is-selected="isSelected"
          @action-selected="isSelected = $event"
        />
      </actions>
    </template>
  </v-form>
</template>

<script>
import { mdiPlus } from '@mdi/js'
import format from 'string-template'
import { mapActions } from 'vuex'
import Actions from '@/kit/components/Actions'
import RelaxationBall from '@/kit/components/relaxation/RelaxationBall'
import RelaxationBalloon from '@/kit/components/relaxation/RelaxationBalloon'
import RelaxationSelect from '@/kit/components/relaxation/RelaxationSelect'
import PreviewRelaxationComponent from '@/components/PreviewRelaxationComponent'

export default {
  name: 'RelaxationChoose',
  components: {
    Actions,
    RelaxationBall,
    RelaxationBalloon,
    RelaxationSelect,
    PreviewRelaxationComponent
  },
  props: {
    scope: {
      type: Object,
      required: false
    },
    params: {
      type: Object,
      required: true
    },
    property: {
      type: String,
      required: false
    },
    showPrevButton: {
      type: Boolean,
      default: true
    }
  },
  data() {
    return {
      mdiPlus,
      notificationId: null,
      session: null,
      isSelected: this.params.selected || 'relaxation-show'
    }
  },
  computed: {
    isPreviewMode() {
      this.params.previewMode ? this.setUXPreviewMode(true) : this.setUXPreviewMode(false)
      return this.params.previewMode
    }
  },
  async mounted() {
    this.setUXPreviewMode(this.params.previewMode)
    await this.sessionStart(this)
  },
  beforeDestroy() {
    this.resetUXState()
  },
  methods: {
    ...mapActions({
      sessionStart: 'schedules/sessionStart',
      setUXPreviewMode: 'ux/setUXPreviewMode',
      resetUXState: 'ux/resetUXState'
    }),
    async next() {
      const link = format(`{baseUrl}/relaxation/${this.isSelected}/{id}`, {
        id: '{id}',
        baseUrl: process.env.VUE_APP_BASE_URL
      })

      await this.$emit('track', {
        event: 'adhere.ly:relaxation:selected',
        link
      })

      await this.$emit('go-to-next-step', {
        link,
        duration: this.params.duration
      })
    }
  }
}
</script>
